module.exports = __webpack_public_path__ + "assets/influences_black.6f48d7c1.svg";